import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: theme.spacing(0.5, 0, 0, 0),
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.mode === 'dark' ? colors.black[200] : colors.black[600],

      '&.Mui-error': { color: colors.red[600] },
    }),
  },
};
